'use client';

import { useEffect, useState } from 'react';

function useKeyboardPress({ keyCode }: { keyCode: string }) {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === keyCode && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setKeyPressed((open) => !open);
      }
    };
    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, [keyCode]);

  return { keyPressed, setKeyPressed };
}

export { useKeyboardPress };
